import React from 'react';
import CardEstatico from './CardEstatico'
import CardAnimado from './CardAnimado'

const ContainerFlip = ({ digit, shuffle, unit }) => {

    // assign digit values
    let currentDigit = digit;
    let previousDigit = digit + 1;
    let cssCor

    // to prevent a negative value
    if (unit === 'horas') {
        previousDigit = previousDigit === 24 ? 0 : previousDigit;
        cssCor = {
            background: "#2d8441"
        };
    } else if (unit !== 'dias') {
        previousDigit = previousDigit === 60 ? 0 : previousDigit;
        cssCor = {
            background: "#f6914e"
        };
    } else {
        cssCor = {
            background: "#4f2e85"
        };
    }

    // add zero
    if (currentDigit < 10) {
        currentDigit = `0${currentDigit}`;
    }
    if (previousDigit < 10) {
        previousDigit = `0${previousDigit}`;
    }

    // shuffle digits
    const digit1 = shuffle ? previousDigit : currentDigit;
    const digit2 = !shuffle ? previousDigit : currentDigit;

    // shuffle animations
    const animation1 = shuffle ? 'fold' : 'unfold';
    const animation2 = !shuffle ? 'fold' : 'unfold';

    return (
        <div className={'flipUnitContainer'}>
            <CardEstatico position={'upperCard'} digit={currentDigit} css={cssCor}/>
            <CardEstatico position={'lowerCard'} digit={previousDigit} css={cssCor}/>
            <CardAnimado digit={digit1} animation={animation1} css={cssCor}/>
            <CardAnimado digit={digit2} animation={animation2} css={cssCor}/>
            <span className="contador-campanha-container__span foreground">{unit}</span>
        </div>
    );
};

export default ContainerFlip;